export default __webpack_public_path__ + "static/media/background.1a71d5cb.jpg";